<div class="max-w-4xl mx-auto p-6 bg-white rounded-xl shadow-lg">
  <!-- User Information (Default View) -->
  <div *ngIf="!isEditing" class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div class="col-span-1 md:col-span-2">
      <h2 class="text-2xl font-serif text-gold mb-4">Profile Information</h2>
    </div>
    <div>
      <p class="text-lg font-serif text-gray-700"><strong>E-mail Address:</strong> {{ user.email }}</p>
    </div>
    <div></div> <!-- Empty div for grid alignment -->
    <div>
      <p class="text-lg font-serif text-gray-700"><strong> Name:</strong> {{ user.firstName }} {{ user.lastName }}</p>
    </div>
   <!-- <div>
      <p class="text-lg font-serif text-gray-700"><strong>Last Name:</strong> {{ user.lastName }}</p>
    </div>
    <div class="col-span-1 md:col-span-2 text-right">
      <button
        class="px-6 py-3 bg-gold text-white rounded-lg hover:bg-gold-dark focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
        (click)="toggleEdit()"
      >
        Modify Information
      </button>
    </div>-->
  </div>

  <!-- Form (Shown when editing) -->
  <div *ngIf="isEditing">
    <div class="padding-top-2x mt-8 hidden lg:hidden"></div>
    <form class="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-white rounded-xl shadow-lg" [formGroup]="formProfile" (ngSubmit)="onSubmit()">
      <!-- Email Field -->
      <div class="col-span-1 md:col-span-2">
        <div class="form-group">
          <label for="account-email" class="block text-lg font-serif text-gold mb-2">E-mail Address</label>
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300" type="email" id="account-email" formControlName="email">
        </div>
      </div>

      <!-- First Name Field -->
      <div>
        <div class="form-group" [ngClass]="{'border-red-500': formProfile.get('firstName').invalid && formProfile.get('firstName').touched}">
          <label for="account-fn" class="block text-lg font-serif text-gold mb-2">First Name</label>
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300" type="text" id="account-fn" formControlName="firstName">
          <div class="text-red-500 text-sm mt-1" *ngIf="formProfile.get('firstName').invalid && formProfile.get('firstName').touched">Please enter your firstname!</div>
        </div>
      </div>

      <!-- Last Name Field -->
      <div>
        <div class="form-group" [ngClass]="{'border-red-500': formProfile.get('lastName').invalid && formProfile.get('lastName').touched}">
          <label for="account-ln" class="block text-lg font-serif text-gold mb-2">Last Name</label>
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300" type="text" id="account-ln" formControlName="lastName">
          <div class="text-red-500 text-sm mt-1" *ngIf="formProfile.get('lastName').invalid && formProfile.get('lastName').touched">Please enter your lastname!</div>
        </div>
      </div>

      <!-- New Password Field -->
      <div>
        <div class="form-group">
          <label for="account-pass" class="block text-lg font-serif text-gold mb-2">New Password</label>
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300" type="password" formControlName="password" id="account-pass">
        </div>
      </div>

      <!-- Confirm Password Field -->
      <div>
        <div class="form-group">
          <label for="account-confirm-pass" class="block text-lg font-serif text-gold mb-2">Confirm Password</label>
          <input class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gold transition duration-300" type="password" formControlName="confirmPassword" id="account-confirm-pass">
        </div>
      </div>

      <!-- Separator and Submit -->
      <div class="col-span-1 md:col-span-2">
        <hr class="border-t-2 border-gray-200 my-6">
        <div class="form-group">
          <div class="text-red-500 text-sm mb-4" *ngIf="profileErrors">{{ profileErrors }}</div>
        </div>
        <div class="text-right space-x-4">
          <button
            class="px-6 py-3 bg-gray-500 text-white rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 transition duration-300"
            type="button"
            (click)="toggleEdit()"
          >
            Cancel
          </button>
          <button
            class="px-6 py-3 bg-gold text-white rounded-lg hover:bg-gold-dark focus:outline-none focus:ring-2 focus:ring-gold transition duration-300"
            type="submit"
            [disabled]="!formProfile.valid"
          >
            Update Profile
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
